import React, { useState, useEffect } from 'react';
import { Divider, Box, makeStyles, Typography } from '@material-ui/core';
import ChatDonut from './CharDonut';
import { round } from 'lodash';
import TerminalComponent from './dashboardssh';
import axios from 'axios';
import { API_BASE_URL } from '@config';
import {LineChart, SelectComponent} from './ChartCpuAvg';


const useStyles = makeStyles(theme => ({
  mainRoot: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  paddingChart: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '40px',
    paddingRight: '40px',
    alignItems: 'flex-center',
    justifyContent: 'flex-center',
  },
  topCard: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#48494a',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    color: 'white',
    textAlign: 'center',
    fontSize: '20px',
    fontWeight: 'bold',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    maxWidth: '1640px',
    [theme.breakpoints.down(1050)]: {
      maxWidth: '800px',
      marginLeft: '0px',
    }
  },
  Title: {
    padding: '10px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  selectCluster: {
    marginRight: '35px',
    marginTop: '10px',
  },
  chart :{
    backgroundColor: '#48494a',
    height: '230px',
    width: '100%',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    display: 'flex',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '2%',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    maxWidth: '1640px',
    [theme.breakpoints.down(1050)]: {
      maxWidth: '800px',
      marginLeft: '0px',
    }
  },
  chartPadding: {
    marginRight: '1%',
    marginLeft: '1%',
    marginBottom: '1%',
    width: '98%',
    height: '95%',
  },
  
  root: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '40px',
    width: '100%',
    padding: '40px',
    [theme.breakpoints.up(1050)]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  stats: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
    [theme.breakpoints.up(1050)]: {
      width: '40%',
    },
  },
  terminal: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
    [theme.breakpoints.up(1050)]: {
      width: '60%',
    },
  },
  terminalDisabled: {
    backgroundColor: '#dddddd',
    color: '#333333',
    fontSize: '16px',
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    borderRadius: '8px',
    alignItems: 'center',
    height: '100%',
  }
}));

export default function Grids(props) {
  const classes = useStyles();
  const [displayTerminal, setDisplayTerminal] = useState(false);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/ui/settings`)
      .then(response => {
        setDisplayTerminal(response.data.displayTerminal);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  return (
    <div className={classes.mainRoot}>
      <div className={classes.root}>
      <Stats {...props} className={classes.stats} />
      {displayTerminal ? (
        <Terminal className={classes.terminal} />
      ) : (
        <div className={`${classes.terminal} ${classes.terminalDisabled}`}>
          <p>Terminal access has been deactivated.</p>
        </div>
      )}
      </div>
      <div className={classes.paddingChart}>
        <div className={classes.topCard}>
          <div className={classes.Title}>Cluster Load Average</div>
          <div className={classes.selectCluster}> <SelectComponent/></div>
        </div>
       <div className={classes.chart}>
        <div className={classes.chartPadding}>
          <LineChart  {...props}  />
        </div>
      </div> 
      </div>
    </div>
  );
}

const Stats = (props) => {
  const servicesInfo = props?.DashboardInfo?.dataservice;
  const useInfo = props?.DashboardInfo?.dataUse;

  const useStyles = makeStyles(() => ({
    title: {
      color: "white",
      margin: "15px",
      textAlign: "center",
    },
    divider: {
      backgroundColor: "white",
      height: "2px",
      width: "70%",
      margin: "20px auto",
    },
    text: {
      padding: "0 7px",
    },
    whiteText: {
      color: "white",
      margin: " 0 15%",
      display: 'flex',
      justifyContent: 'space-between',
    },
    whiteText2: {
      float: "left",
      color: "white",
      marginLeft: "15%",
      clear: "left"
    },
    circleRed: {
      width: "7px",
      height: "7px",
      borderRadius: "50%",
      backgroundColor: "red",
      float: "right",
      marginTop: "7px",
      marginRight: "30%"
    },
    circleGreen: {
      width: "7px",
      height: "7px",
      borderRadius: "50%",
      backgroundColor: "green",
      float: "right",
      marginTop: "7px",
      marginRight: "30%"
    },
    SquareBox: {
      marginTop: "2%",
      margin: "auto",
      aspectRatio: 1.8,
      height: "100%"
    },
    cpumenServ: {
      clear: "both",
      color: "#f57d56",
      marginLeft: "16%",
      fontSize: "small"
    },
    redText: {
      color: 'white',
      background: 'red',
      borderRadius: '5px'
    },
    yellowText: {
      color: 'white',
      background: '#CCAC00',
      borderRadius: '5px'
    },
  }));

  let latestsystemInfo = {
    MenPrenceUsed: 0,
    MenTotal: 0,
    service: "system",
    diskTotal: 0,
    diskUsedPercent: 0,
    CpuPercentUsed: 0,
  };

  if (servicesInfo != null) {
    const systemInfo = servicesInfo.filter(objeto => objeto.service === "system").map(objeto => objeto);
    if (systemInfo.length > 1) {
      latestsystemInfo = systemInfo.reduce((prev, current) => {
        return (new Date(current.createdAt) > new Date(prev.createdAt)) ? current : prev
      })
    } else if (systemInfo.length === 1) {
      latestsystemInfo = systemInfo[0];
    }
  }

  let services = [];
  if (servicesInfo != null) {
    //Set
    const servicesset = [...new Set(servicesInfo.map(item => item.service !== "system" ? item.service : null))];
    //remover null
    services = servicesset.filter(item => item !== null);
  }

  const classes = useStyles();

  function ShowServices() {
    return (
      <>
        {services.map((name, index) => {

          let latest = {
            service: name,
            Runing: false,
            CpuPercentUsed: 0,
            MenPrenceUsed: 0,
          };

          const s = servicesInfo.filter(objeto => objeto.service === name).map(objeto => objeto);
          if (s.length > 1) {
            latest = s.reduce((prev, current) => {
              return (new Date(current.createdAt) > new Date(prev.createdAt)) ? current : prev
            })
          } else if (s.length === 1) {
            latest = s[0];
          }

          return (
            <div key={index}>
              <Typography variant="body1" className={classes.whiteText2}>
                {name}
              </Typography>
              {(latest.Runing) ? <div className={classes.circleGreen}></div> :
                <div className={classes.circleRed}></div>}
              {(latest.CpuPercentUsed > 50 || latest.MenPrenceUsed > 50) ? <div className={classes.cpumenServ} >cpu: {latest.CpuPercentUsed}%, men: {latest.MenPrenceUsed}%</div> :
                <div ></div>}
            </div>
          );
        })}
      </>
    );
  }

  return (
    <Box sx={{
      height: '100%',
      maxHeight: '560px',
      width: '100%',
      minWidth: '300px',
      maxWidth: '800px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }} >
      <Box sx={{
        height: '50%',
        width: '100%',
        maxWidth: '500px',
      }} >
        <ChatDonut
          jobRunning={useInfo?.jobRunning ?? 0}
          jobWaiting={useInfo?.jobQueued ?? 0}
          UnusedNodes={useInfo?.unusedNodes ?? 0}
          UnusedCore={useInfo?.unusedCore ?? 0}
          UnusedGpus={useInfo?.unusedGpus ?? 0}
        />
      </Box>
      <Box sx={{
        height: '48%',
        width: '100%',
        marginTop: '2%',
      }} >
        <Box sx={{ bgcolor: '#48494a', width: '49.3%', height: '100%', float: 'left', borderRadius: '8px' }} >
          <Typography variant="h6" className={classes.title}>
            Heidi Server
          </Typography>
          <Divider className={classes.divider} variant="middle" />
          <Typography variant="body1" className={`${classes.text} ${classes.whiteText}`}>
            <span>Processor:</span>
            <span>{round(latestsystemInfo.CpuPercentUsed)}%</span>
          </Typography>
          <Typography variant="body1" className={`${classes.text} ${classes.whiteText}`}>
            <span>Memory:</span>
            <span>{round(latestsystemInfo.MenPrenceUsed)}% of {latestsystemInfo.MenTotal}GB</span>
          </Typography>
          <Typography variant="body1" className={`${classes.text} ${classes.whiteText} ${latestsystemInfo.diskUsedPercent > 90 ? classes.redText : latestsystemInfo.diskUsedPercent > 75 ? classes.yellowText : null}`}>
            <span>Disk Space:</span>
            <span>{round(latestsystemInfo.diskUsedPercent)}% of {latestsystemInfo.diskTotal}GB</span>
          </Typography>
        </Box>
        <Box sx={{ width: '1.4%', height: '100%', float: 'left' }} />
        <Box sx={{ width: '49.3%', height: '100%', float: 'left', bgcolor: '#48494a', borderRadius: '8px' }} >
          <Typography variant="h6" className={classes.title} key={"ServicesRunning"}>
            Services
          </Typography>
          <Divider className={classes.divider} variant="middle" />
          {ShowServices()}
        </Box>
      </Box>
    </Box>
  )
}

const Terminal = () => {
  return (
    <Box sx={{ overflow: 'hidden', bgcolor: '#010000', height: '100%', maxHeight: '560px', width: '100%', minWidth: '300px', maxWidth: '800px', borderRadius: '8px' }} >
      <div style={{ overflow: 'hidden', margin: '10px' }}>
        <TerminalComponent />
      </div>
    </Box>
  )
}